// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

import $ from 'jquery';


export default class DatepickerSelectTab extends WebComponent {
  constructor(props) {
    super(props);
    this.setActiveLink = this.setActiveLink.bind(this);
  };

  didMount() {
    const {
      activeClass,
    } = this.props;
    const currentDateRange = this.fixRange(this.element.getAttribute('data-current-date-range'));

    this.links = this.element.querySelectorAll('a');
    this.activeClass = activeClass;
    this.activeLinkSet = false;

    Array.from(this.links).forEach(target => {
      const activeValue = target.href.split('#')[1];
      const targetInput = document.querySelector('#parameter-datum-konani_datepicker');
      let dateRange;

      if (activeValue == 'all') {
        dateRange = '';
        target.setAttribute('data-set-value', dateRange);
      }
      else if (activeValue == 'thisWeek') {
        dateRange = this.getThisWeek();
        target.setAttribute('data-set-value', dateRange);
      }
      else if (activeValue == 'thisMonth') {
        dateRange = this.getThisMonth();
        target.setAttribute('data-set-value', dateRange);
      }
      else {
        dateRange = 'custom';
      }

      if ((dateRange == currentDateRange) || (!this.activeLinkSet && dateRange == 'custom') || (dateRange == '' && currentDateRange == '0,0')) {
        this.setActiveLink(target);
        this.activeLinkSet = true;
      }

      target.addEventListener('click', (event) => {
        if (activeValue == 'all' || activeValue == 'thisWeek' || activeValue == 'thisMonth') {
          targetInput.value = target.getAttribute('data-set-value');
          $(targetInput).trigger('change');
        }

        event.preventDefault();
      });
    });
  };

  setActiveLink(targetElement) {
    const activeLink = this.element.querySelector('.' + this.activeClass);
    activeLink.classList.remove(this.activeClass);
    targetElement.classList.add(this.activeClass);
  }

  getThisWeek() {
    const d = new Date();
    const currentWeekDay = d.getDay();
    const diff = currentWeekDay === 0 ? 6 : currentWeekDay-1;
    const monday = new Date(new Date(d).setDate(d.getDate()- diff));
    const sunday = new Date(new Date(monday).setDate(monday.getDate()+6));
    return this.convertDate(monday) + ',' + this.convertDate(sunday);
  }

  getThisMonth() {
    const d = new Date();
    const firstDay = new Date(d.getFullYear(), d.getMonth(), 1);
    const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0);
    return this.convertDate(firstDay) + ',' + this.convertDate(lastDay);
  }

  makePseudoDecimal(value) {
    return value.substring(0, 4) + '.' + value.substring(4);
  }

  convertDate(date) {
    return this.makePseudoDecimal(date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2));
  }

  fixRange(range) {
    let splitRange = range.split(',');
    if (splitRange[0].length == 8) {
      splitRange[0] = splitRange[0] + '0';
    }
    if (splitRange[1].length == 8) {
      splitRange[1] = splitRange[1] + '0';
    }
    return (splitRange.join(','));
  }

}

DatepickerSelectTab.defaultProps = {
  activeClass: 'active',
};



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/components/DatepickerSelectTab.js